<template>
  <div
    class="app-tooltip"
    @mouseenter="showTooltip = true"
    @touchstart="showTooltip = true"
    @mouseleave="showTooltip = false"
    @touchend="showTooltip = false"
  >
    <span v-if="!$slots.default" class="app-tooltip__default-text">?</span>
    <slot />
    <transition name="fade">
      <span
        v-if="showTooltip"
        class="app-tooltip__content"
        :class="`is-${placement}`"
      >
        <slot name="content" />
      </span>
    </transition>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue'

export default defineComponent({
  name: 'AppTooltip',
  props: {
    placement: {
      type: String,
      default: 'bottom',
    },
  },
  setup() {
    const showTooltip = ref(false)

    return { showTooltip }
  },
})
</script>

<style lang="scss" scoped src="./Index.scss" />
